import styled from 'styled-components';

import { PLATFORM_COLORS } from '../constants';

export const AvatarContainer = styled.div`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  flex-shrink: 0;
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
`;

export const AvatarInitials = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: ${({ platform }) => PLATFORM_COLORS[platform] || PLATFORM_COLORS.facebook};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: ${({ size }) => Math.floor(size * 0.4)}px;
  text-transform: uppercase;
  user-select: none;
  position: absolute;
  top: 0;
  left: 0;
`;
